import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

export function useDeleteCommentDraft(
  draftGid,
  onDone = () => {},
  onError = () => {}
) {
  const mutationFactory = useCallback(() => {
    const query = `mutation deleteDraft($gid: ID!) {
        deleteDraft(gid: $gid) {
            successMessage
        }                    
      }
  `;

    const resolver = ({ data }) => {
      return {
        data: data.deleteDraft.successMessage,
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const [mutation, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone,
    onError,
  });

  return {
    isDeletingDraft: loading,
    deleteDraft: async () => {
      if (!draftGid) {
        return Promise.resolve();
      }
      return mutation(
        { gid: draftGid },
        {
          successMsg: "Draft successfully deleted.",
          defaultErrorMsg: "Failed to delete draft.",
        }
      );
    },
  };
}

export default useDeleteCommentDraft;
